import React, { useState } from 'react';
import AuthLayout from './AuthLayout';
import { supabase } from '../../lib/supabase';
import { ShieldCheck, ArrowRight } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

const OTPVerification = ({ isDarkMode, setIsDarkMode }) => {
    const [otp, setOtp] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const location = useLocation();
    const navigate = useNavigate();
    const { email, phone } = location.state || {};

    const handleVerify = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const { error: verifyError } = await supabase.auth.verifyOtp({
                email,
                token: otp,
                type: 'signup'
            });

            if (verifyError) throw verifyError;
            navigate('/dashboard');
        } catch (err) {
            setError(err.message || 'Verification failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthLayout
            title="Verification"
            subtitle="Sent to your sacred vessel"
            isDarkMode={isDarkMode}
            setIsDarkMode={setIsDarkMode}
        >
            <form onSubmit={handleVerify} className="space-y-6">
                <div className="text-center mb-8">
                    <div className={`w-20 h-20 rounded-[24px] flex items-center justify-center mx-auto mb-6 shadow-inner ${isDarkMode ? 'bg-blue-500/10' : 'bg-blue-50'}`}>
                        <ShieldCheck className="text-blue-500 w-10 h-10" />
                    </div>
                </div>

                <p className={`text-sm text-center mb-6 font-medium ${isDarkMode ? 'text-gray-400' : 'text-slate-500'}`}>
                    Enter the code sent to <span className="text-blue-500 font-bold">{email || phone}</span>
                </p>

                <div>
                    <label className={`block text-[10px] font-black uppercase tracking-widest mb-2 text-center ${isDarkMode ? 'text-gray-500' : 'text-slate-400'}`}>
                        OTP Code
                    </label>
                    <input
                        type="text"
                        required
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        className={`w-full text-center text-3xl font-black tracking-[0.5em] py-5 rounded-[24px] border transition-all focus:ring-2 outline-none ${isDarkMode
                                ? 'bg-white/5 border-white/10 text-white focus:ring-blue-500/50'
                                : 'bg-slate-50 border-slate-200 text-slate-900 focus:ring-blue-500/20'
                            }`}
                        placeholder="000000"
                        maxLength={6}
                    />
                </div>

                {error && (
                    <div className="bg-red-500/10 border border-red-500/20 text-red-500 text-xs font-black p-4 rounded-xl text-center uppercase tracking-tighter">
                        {error}
                    </div>
                )}

                <button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-gradient-to-r from-blue-600 to-orange-500 hover:scale-[1.02] active:scale-[0.98] text-white font-black py-5 rounded-[24px] shadow-xl shadow-orange-500/20 flex items-center justify-center space-x-3 transition-all disabled:opacity-50"
                >
                    <span>{loading ? 'Verifying...' : 'Unlock Sanctuary'}</span>
                    <ArrowRight className="w-5 h-5" />
                </button>

                <div className="text-center">
                    <button
                        type="button"
                        className={`text-xs font-black uppercase tracking-widest hover:underline ${isDarkMode ? 'text-gray-600' : 'text-slate-400'}`}
                    >
                        Resend Code
                    </button>
                </div>
            </form>
        </AuthLayout>
    );
};

export default OTPVerification;
